// import React from "react";
import { useState } from "react";
import "./SecurityOneCheckInByCode.scss";

import OtpInput from "react-otp-input";

const SecurityOneCheckInByCode = () => {
  const [code, setCode] = useState("");

  const handleWheel = (e) => {
    e.preventDefault();
  };
  return (
    <div className="security-one-check-in-code-parent container">
      <div className="d-flex justify-content-between align-items-center">
        <div className="security-one-check-in-code-parent-left d-flex flex-column col-8">
          <h5>Check In By Code</h5>
          <p style={{ fontSize: "12px" }}>
            Enter Visitor 6 Digit Code To Quick Access
          </p>
        </div>
        <div className="col-4 security-one-check-in-code-parent-right">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="40px"
            viewBox="0 -960 960 960"
            width="40px"
            fill="currentColor"
          >
            <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q134 0 227 93t93 227q0 134-93 227t-227 93Zm0-80q100 0 170-70t70-170q0-17-2.5-33.5T710-546q-15 3-30 4.5t-30 1.5q-63 0-120-24t-102-70q-28 57-77 99t-111 61q3 98 72.5 166T480-240ZM256-566q44-23 67-53.5t45-72.5q-38 20-67 52.5T256-566Zm124 166q-17 0-28.5-11.5T340-440q0-17 11.5-28.5T380-480q17 0 28.5 11.5T420-440q0 17-11.5 28.5T380-400Zm270-220h12q6 0 12-1-33-45-83.5-72T480-720h-12q-6 0-11 1 39 45 82.5 72T650-620Zm-70 220q-17 0-28.5-11.5T540-440q0-17 11.5-28.5T580-480q17 0 28.5 11.5T620-440q0 17-11.5 28.5T580-400ZM40-720v-120q0-33 23.5-56.5T120-920h120v80H120v120H40ZM240-40H120q-33 0-56.5-23.5T40-120v-120h80v120h120v80Zm480 0v-80h120v-120h80v120q0 33-23.5 56.5T840-40H720Zm120-680v-120H720v-80h120q33 0 56.5 23.5T920-840v120h-80Zm-383 1Zm-89 27Z" />
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="40px"
            viewBox="0 -960 960 960"
            width="40px"
            fill="currentColor"
          >
            <path d="M481-781q106 0 200 45.5T838-604q7 9 4.5 16t-8.5 12q-6 5-14 4.5t-14-8.5q-55-78-141.5-119.5T481-741q-97 0-182 41.5T158-580q-6 9-14 10t-14-4q-7-5-8.5-12.5T126-602q62-85 155.5-132T481-781Zm0 94q135 0 232 90t97 223q0 50-35.5 83.5T688-257q-51 0-87.5-33.5T564-374q0-33-24.5-55.5T481-452q-34 0-58.5 22.5T398-374q0 97 57.5 162T604-121q9 3 12 10t1 15q-2 7-8 12t-15 3q-104-26-170-103.5T358-374q0-50 36-84t87-34q51 0 87 34t36 84q0 33 25 55.5t59 22.5q34 0 58-22.5t24-55.5q0-116-85-195t-203-79q-118 0-203 79t-85 194q0 24 4.5 60t21.5 84q3 9-.5 16T208-205q-8 3-15.5-.5T182-217q-15-39-21.5-77.5T154-374q0-133 96.5-223T481-687Zm0-192q64 0 125 15.5T724-819q9 5 10.5 12t-1.5 14q-3 7-10 11t-17-1q-53-27-109.5-41.5T481-839q-58 0-114 13.5T260-783q-8 5-16 2.5T232-791q-4-8-2-14.5t10-11.5q56-30 117-46t124-16Zm0 289q93 0 160 62.5T708-374q0 9-5.5 14.5T688-354q-8 0-14-5.5t-6-14.5q0-75-55.5-125.5T481-550q-76 0-130.5 50.5T296-374q0 81 28 137.5T406-123q6 6 6 14t-6 14q-6 6-14 6t-14-6q-59-62-90.5-126.5T256-374q0-91 66-153.5T481-590Zm-1 196q9 0 14.5 6t5.5 14q0 75 54 123t126 48q6 0 17-1t23-3q9-2 15.5 2.5T744-191q2 8-3 14t-13 8q-18 5-31.5 5.5t-16.5.5q-89 0-154.5-60T460-374q0-8 5.5-14t14.5-6Z" />
          </svg>
        </div>
      </div>

      {/* ENTER VISITOR CODE START */}
      <div className="security-one-enter-visitor-code">
        <OtpInput
          value={code}
          onChange={setCode}
          numInputs={6}
          renderSeparator={
            <span style={{ margin: "10px 5px 20px 5px" }}>-</span>
          }
          renderInput={(props) => (
            <input
              {...props}
              onWheel={handleWheel}
              inputMode="numeric"
              style={{
                width: "40px",
                height: "40px",
                border: "1px solid gray",
                textAlign: "center",
                borderRadius: "5px",
                margin: "10px 0px 20px 0px",
              }}
            />
          )}
        />
        <button className="btn_fill" style={{ minWidth: "100%" }}>
          Submit
        </button>
        <div className="small_margin_div"></div>
        {/* ENTER VISITOR CODE END */}
      </div>
    </div>
  );
};

export default SecurityOneCheckInByCode;
